/* happilystory-poster-grid.js — logique fiche grille (externalisée pour alléger le HTML).
   Config injectée par la fiche via window.HSP_CFG (voir happilystory-poster-grid.liquid). */
(function () {
  var root = document.querySelector('section.hsp[data-section-id="' + HSP_CFG.sectionId + '"]')
          || document.querySelector('section.hsp');
  if (!root) return;

  // Variant de l'upsell "Sans la mention happilystory" (2,99 €).
  // = id retourne par scripts/shopify/create-watermark-upsell.mjs.
  var WATERMARK_VARIANT_ID = 62562593964362;
  var WATERMARK_PRICE_CENTS = 299;

  // ---------- Personnalisation des illustrations (upsell +5,99 €) ----------
  // NB : PERSO_VARIANT_ID + PREMIUM_MANIFEST_URL sont declares DANS l'IIFE perso
  // (plus bas) et non ici : si Shopify resegmente le <script> au runtime, le builder
  // perso ne voit plus le scope externe -> on garde ces deux constantes au plus pres
  // de leur unique usage (builder / loadManifest), dans le meme scope interne.
  var PERSO_PRICE_CENTS = 599;

  // ---------- LAYOUT : coordonnees PARTAGEES (bakees du _grids-registry.json) ----------
  // Identiques pour toutes les grilles. viewBox overlay = 2400x3200 = dimensions du
  // canvas. text-anchor = middle. Une seule source de verite cote print + overlay.
  var LAYOUT = {
    prenom: { x: 1200, y: 480, size: 110 },
    dates: [
      { x: 430, y: 1155, size: 72 }, { x: 1200, y: 1155, size: 72 }, { x: 1970, y: 1155, size: 72 },
      { x: 430, y: 1725, size: 72 }, { x: 1200, y: 1725, size: 72 }, { x: 1970, y: 1725, size: 72 },
      { x: 430, y: 2295, size: 72 }, { x: 1200, y: 2295, size: 72 }, { x: 1970, y: 2295, size: 72 },
      { x: 430, y: 2865, size: 72 }, { x: 1200, y: 2865, size: 72 }, { x: 1970, y: 2865, size: 72 }
    ],
    // Signature happilystory (centre bas, viewBox 2400x3200).
    // y=3035 (remonte de 3120) pour ne pas etre touchee par la bordure decorative.
    signature: { x: 1200, y: 3035, size: 56 }
  };

  // ---------- GRIDS : libelles des 12 etapes par handle (bakes du registry) ----------
  // Au runtime : labels = GRIDS[handle] (fallback = premieres-fois). DATA-DRIVEN :
  // cette section sert toutes les grilles sans modifier le code.
  var GRIDS = {
    "affiche-premiere-annee":      ["Le jour J","Retour à la maison","Premier sourire","Tient sa tête","Premier éclat de rire","S'assoit seul","Fait du 4 pattes","Première dent","Se met debout","Premiers pas","Premier mot","1 an"],
    "affiche-premieres-fetes":     ["Premier Noël","Premier Nouvel An","Premier Pâques","Premier Halloween","1re fête des mères","1re fête des pères","Premier été","Premier hiver","Première neige","Premier printemps","Premier automne","Premier anniversaire"],
    "affiche-premieres-fois-2":    ["Premier biberon","Premier hochet","Première promenade","Premier doudou","Premier areu","Première purée","1re sieste tout seul","Premier copain","Premier livre","Balade en poussette","Premier bain de mer","Premier câlin du soir"],
    "affiche-bienvenue-bebe":      ["Le grand jour","Premier regard","Premier câlin","Premier biberon","Premier bain","Premier dodo","Retour maison","Premier change","Première tétée","Premier sourire","Première nuit","Premier mois"],
    "affiche-premieres-vacances":  ["Première mer","Château de sable","Première montagne","Première baignade","Premier camping","Premier avion","Première rando","Première pêche","Premier coquillage","Première glace","Premier feu de camp","Coucher de soleil"],
    "affiche-premieres-fois-grand":["Vélo sans roulettes","Première rentrée","Première dent perdue","Nuit chez les copains","Premier spectacle","Premier livre lu seul","Premier voyage","Premier animal","Premier dessin","Première médaille","Premier camping","Première recette"],
    "affiche-annee-maternelle":    ["La rentrée","Première copine","Première peinture","Sieste à l'école","Sortie scolaire","Premier spectacle","Première cantine","Première lettre écrite","Premier puzzle","Premier déguisement","Première chanson","La fin d'année"],
    "affiche-mes-exploits":        ["Premiers pas","Premier vélo","Première brasse","Premier roller","Premier but","Première grimpe","Premier dessin","Première lecture","Premier puzzle","Première recette","Premier camping","Première scène"],
    "affiche-je-grandis":          ["Naissance","1 an","2 ans","3 ans","4 ans","5 ans","6 ans","7 ans","8 ans","9 ans","10 ans","Mon prochain anniv"],
    "affiche-premiers-a-la-maison":["Dodo dans sa chambre","Premier doudou","Repas à table","Premier pot","Bougie soufflée","Première bêtise","Premier mot à maman","Premier mot à papa","Câlin au chien/chat","Dessin sur le mur","Première cabane","Réveil tout seul"],
    "premieres-fois":              ["Première nuit complète","Premier sourire","Premier bain","Premier câlin","Premiers pas","Première dent","Premier mot","Premier éclat de rire","Premier repas","Premier dodo","Première sortie","Premier anniversaire"],
    "affiche-notre-histoire":      ["Notre rencontre","Premier regard","Premier rendez-vous","Premier baiser","Premier je t'aime","Premier voyage","Notre chez-nous","Notre animal","La demande","Nos fiançailles","Notre mariage","Pour toujours"],
    "affiche-nos-voyages":         ["Premier voyage","Première mer","Première montagne","Premier road-trip","Premier avion","Première grande ville","Premier pays lointain","Premier camping","Première plage","Coucher de soleil","Première rando","Prochaine destination"],
    "affiche-nos-fetes":           ["Noël en famille","Nouvel An","Pâques","Les anniversaires","Fête des mères","Fête des pères","Vacances d'été","Réunion de famille","Halloween","La galette des rois","Le grand repas","Prochaine fête"],
    "affiche-mon-noel":            ["Le sapin","La lettre au Père Noël","Les biscuits","La déco","Le marché de Noël","La veillée","Les cadeaux","Le réveillon","La bûche","Les chants","La photo de famille","Le prochain Noël"],
    "affiche-ma-grossesse":        ["Le test positif","La 1re écho","L'annonce","Les 1ers achats","Les premiers coups","On connaît le sexe","Le prénom choisi","La 2e écho","La chambre prête","La valise prête","Le terme","Le grand jour"],
    "affiche-notre-maison":        ["L'annonce","La 1re visite","L'offre acceptée","La signature","La remise des clés","Le déménagement","La 1re nuit","Les cartons vides","La 1re déco","La crémaillère","Le jardin","Notre chez-nous"],
    "affiche-parents":             ["La 1re nuit blanche","Le 1er change","Le 1er bain donné","La 1re promenade","Le 1er biberon","Le 1er areu","Le 1er fou rire","La 1re maladie","La 1re nounou","Le 1er maman-papa","La 1re séparation","1 an de parents"],
    "affiche-mamie-papy":          ["Notre 1re rencontre","Le 1er câlin","La 1re histoire","Les 1res vacances","Le 1er gâteau ensemble","La 1re bêtise","La 1re promenade","Le 1er jardinage","La 1re nuit chez eux","Le 1er secret","La 1re pêche","Notre complicité"],
    "affiche-annee-ecole":         ["La rentrée","La maîtresse","Mon cartable","La cantine","La récré","Ma première dictée","La sortie scolaire","Le spectacle","La photo de classe","Mon meilleur copain","Ma 1re lecture","Les grandes vacances"],
    "affiche-vacances-mer":        ["La plage","Le château de sable","1re baignade","Les coquillages","La glace","Balade en bateau","Pêche à l'épuisette","Coucher de soleil","Le cerf-volant","La crêpe","La bouée","Mes souvenirs"],
    "affiche-fois-montagne":       ["1re neige","La luge","Bonhomme de neige","Chocolat chaud","Le ski","Bataille de boules","Le télésiège","La raclette","Les sapins","L'igloo","Le flocon","Le grand air"],
    "affiche-fois-gourmand":       ["1re glace","1er gâteau","1ers légumes","1re crêpe","1er chocolat","1er fruit","1re cuisine","1er resto","1er pique-nique","1er bonbon","1er goûter","1er marché"],
    "affiche-fois-artiste":        ["1er dessin","1re peinture","1re musique","1re danse","1re chanson","1er spectacle","1re photo","1re sculpture","1er bricolage","1er déguisement","1er poème","1re œuvre"],
    "affiche-fois-nature":         ["1re fleur cueillie","1er papillon","1re cabane","1er feu de camp","1re rivière","Étoile filante","1er jardin","1er nid","1er arc-en-ciel","Balade en forêt","1er potager","Coucher de soleil"],
    "affiche-mes-voyages":         ["1er avion","1re valise","1re plage","1re montagne","1er train","1er passeport","1re carte postale","1er hôtel","1re découverte","1er souvenir","1re photo","1re aventure"],
    "affiche-jour-bapteme":        ["La colombe","L'eau bénite","La bougie","La croix","La robe blanche","L'église","La bénédiction","Parrain & marraine","Les fleurs","Le gâteau","Les cadeaux","La photo de famille"],
    "affiche-jour-communion":      ["Le calice","L'hostie","La croix","Les épis de blé","La bougie","La prière","L'aube","L'église","Le missel","La colombe","Couronne fleurie","Le repas de fête"],
    "affiche-fois-sport":          ["Premier but","Premier vélo","Première brasse","Première danse","Première gym","Premier tennis","Premier ski","Première course","Première escalade","Premier roller","Premier judo","Ma médaille"],
    "affiche-fois-jardin":         ["Ma première graine","Mon arrosoir","Ma première fleur","Mon potager","Ma brouette","Le papillon","La coccinelle","Ma récolte","La cabane","L'escargot","L'abeille","Le nichoir"],
    "affiche-mon-doudou":          ["Notre 1re rencontre","Le 1er câlin","La 1re nuit","La 1re sieste","Le 1er voyage","La 1re bêtise","Le 1er goûter","Le 1er secret","La 1re photo","La 1re promenade","Le 1er dodo","Notre complicité"],
    "affiche-premiere-rentree":    ["Le cartable","Le doudou","La maîtresse","Les copains","Le goûter","La sieste","La peinture","La comptine","La cour","La cantine","Le retour","La fierté"],
    "affiche-fois-musique":        ["Ma 1re chanson","La guitare","Le piano","Le tambour","Les maracas","Ma 1re danse","La comptine","Le spectacle","Le micro","La flûte","Le xylophone","Les applaudissements"],
    "affiche-mon-cirque":          ["Le chapiteau","Le jonglage","Le trapèze","Le clown","Le ballon","Le tour de magie","La roulade","Le funambule","Les confettis","L'étoile","Les applaudissements","Le spectacle"],
    "affiche-fois-piscine":        ["Mon 1er bain","Mes brassards","Le toboggan","Le plongeon","Ma bouée","Ma 1re brasse","Les éclaboussures","Le château d'eau","La serviette","Mes lunettes","Le canard","Ma médaille"],
    "affiche-quatre-saisons":      ["Le bourgeon","Les fleurs","Le soleil","La glace","Les feuilles","Le champignon","Le flocon","Le bonhomme de neige","La pluie","L'arc-en-ciel","La récolte","Le cocooning"],
    "affiche-fois-copains":        ["1re rencontre","1er jeu","1er fou rire","1er secret","1er goûter","1re cabane","1re dispute","1re réconciliation","1er anniversaire","1re photo","1re sortie","Notre amitié"],
    "affiche-fois-anniv":          ["Le gâteau","Les bougies","Les ballons","Les cadeaux","Les confettis","La couronne","Les invités","Les jeux","La guirlande","Le chapeau","La surprise","La photo"],
    "affiche-petit-chef":          ["Le tablier","Le fouet","Le rouleau","Le gâteau","La crêpe","Les cookies","La salade de fruits","Le pain","Le chocolat chaud","La glace maison","Le marché","La dégustation"],
    "affiche-mes-jeux":            ["Les cubes","Le puzzle","Le doudou","La toupie","Le ballon","Cache-cache","La dînette","La petite voiture","Le dessin","La construction","La marelle","Le jeu de société"],
    "affiche-fois-bricoleur":      ["Le marteau","La cabane","La peinture","La plantation","Le dessin","Le découpage","Le collage","La construction","Le jardinage","La réparation","L'invention","La fierté"],
    "affiche-fois-ferme":          ["Le tracteur","La botte de foin","Les œufs","Le potager","L'épouvantail","La pomme","L'arrosoir","La grange","La brouette","La ruche","Le moulin","La récolte"],
    "affiche-premiers-jours":      ["Le 1er regard","Le 1er câlin","La 1re tétée","Le 1er bain","La 1re nuit","Le 1er sourire","La 1re sortie","Le 1er doudou","La 1re visite","Le 1er rêve","Le 1er areu","Retour à la maison"],
    "affiche-mes-nuits-bebe":      ["Le berceau","Le doudou","La veilleuse","La berceuse","Les étoiles","La lune","Le mobile","Le 1er dodo","La tétée de nuit","Le câlin","Le rêve","Le réveil"],
    "affiche-bienvenue-monde":     ["L'annonce","La valise","La maternité","Le 1er cri","Le bracelet","La 1re photo","Les faire-part","Les fleurs","Les cadeaux","Le retour","La famille","L'amour"],
    "affiche-ma-premiere-annee-saisons": ["Fleur de printemps","Petit papillon","Arc-en-ciel","Soleil d'été","1re glace","Jours à la plage","Feuille d'automne","Balade sous la pluie","Petite citrouille","1er flocon","Bonhomme de neige","Câlin d'hiver"],
    "affiche-notre-mariage":       ["La demande","Les préparatifs","La cérémonie","Les vœux","Les alliances","Le 1er baiser","La 1re danse","Le bouquet","Le vin d'honneur","La pièce montée","Le bal","Le voyage de noces"],
    "affiche-nos-fiancailles":     ["La demande","La bague","Le oui","Le champagne","Les fleurs","L'annonce","La fête","Les amis","La photo","Le projet","Le baiser","Notre histoire"]
  };

  // ---------- PALETTES : {c1..c6, bg, ink, label} par palette (bakees du registry) ----------
  // La "Couleur de l'affiche" fixe l'ink par defaut (le swatch texte peut override).
  // c1..c6 = couleurs de recoloration des pictos (var --c1..--c6 cote SVG inline),
  // bg = couleur de fond de l'affiche (= fill du cache qui repeint une case patchee).
  // IMPORTANT : valeurs EXACTES du _grids-registry.json (= ce qui est peint dans les
  // canvas cuits). bg sert au cache du patch (doit etre invisible) ; c1..c6 servent a
  // recoloriser un picto remplace pour qu'il matche les pictos d'origine.
  var PALETTES = {
    "sauge":      { label: "Sauge",      ink: "#4A3B3F", bg: "#FBF6EE",
                    c1: "#AFC3A6", c2: "#8FAE93", c3: "#E8C9B0", c4: "#F4E3C2", c5: "#FBF4EA", c6: "#4A3B3F" },
    "rose":       { label: "Rose",       ink: "#5A3E4A", bg: "#FCF4F2",
                    c1: "#EBB9C0", c2: "#D98C9A", c3: "#F3D2C4", c4: "#F7E6C4", c5: "#FCF2F1", c6: "#5A3E4A" },
    "bleu":       { label: "Bleu",       ink: "#3D4A57", bg: "#F4F7FB",
                    c1: "#A9C4D6", c2: "#7FA3BC", c3: "#E6D2B8", c4: "#F4E7C7", c5: "#F2F6FA", c6: "#3D4A57" },
    "terracotta": { label: "Terracotta", ink: "#5A3A2C", bg: "#FBF2E9",
                    c1: "#D89A7E", c2: "#C2785C", c3: "#E7C49C", c4: "#F2DDB4", c5: "#FBF1E6", c6: "#5A3A2C" },
    "soleil":     { label: "Soleil",     ink: "#4E4226", bg: "#FCF8EC",
                    c1: "#F0D27E", c2: "#D6A94B", c3: "#F1D9B0", c4: "#FAEEC8", c5: "#FDF8EC", c6: "#4E4226" },
    "lavande":    { label: "Lavande",    ink: "#41374F", bg: "#F6F2FA",
                    c1: "#C6B6DE", c2: "#9C84C0", c3: "#E6D6C2", c4: "#EFE6D0", c5: "#F8F4FB", c6: "#41374F" },
    "peche":      { label: "Pêche",      ink: "#5A3328", bg: "#FDF3EE",
                    c1: "#F2B79A", c2: "#E08E6E", c3: "#F5D7BE", c4: "#FAE7CF", c5: "#FDF5EE", c6: "#5A3328" },
    "lin":        { label: "Lin",        ink: "#454039", bg: "#F7F4EE",
                    c1: "#CFC6B4", c2: "#A89C85", c3: "#E0D2BE", c4: "#EFE7D7", c5: "#F9F6EF", c6: "#454039" }
  };
  var HERO_PALETTE = "sauge"; // = heroPalette du registry (= featured)

  // ---------- BORDERS : 16 bordures decoratives (assets border-<key>.svg) ----------
  // Bakees en Liquid : { key, label, url }. La bordure est GRATUITE. "Aucune" = pas
  // de bordure (defaut). Les SVG utilisent currentColor => recoloration via style.color.
  var BORDERS = HSP_CFG.borders;

  // ---------- MOTIFS : fonds decoratifs (GRATUIT), generes cote client ----------
  // Chaque entree = function(pal) -> chaine SVG interne (sans <svg>), viewBox
  // "0 0 2400 3200". Deterministe (rng seede par id). Disperses EN ANNEAU AUTOUR de
  // CHAQUE picto (12 centres PCX×PCY), en evitant le cone du bas (libelle + date).
  // pal = PALETTES[canvasPalette] (c1..c6, bg... PAS d'accent -> retombe sur c2).
  // Doit rester STRICTEMENT identique au portage worker (renderAffiche.js buildGridMotif)
  // pour que l'impression matche l'ecran. Repris du proof tools/affiches/grid/_proof-fonds.mjs.
  var MOTIF_W = 2400, MOTIF_H = 3200;
  // PRNG deterministe (identique au proof).
  function motifRng(seed) {
    var s = 0; for (var i = 0; i < seed.length; i++) s = (s * 31 + seed.charCodeAt(i)) >>> 0;
    return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
  }
  // Etoile 4 branches (repris du proof).
  function motifStar(cx, cy, r, fill, op) {
    var p = [];
    for (var i = 0; i < 8; i++) {
      var a = Math.PI / 4 * i - Math.PI / 2;
      var rr = (i % 2) ? r * 0.42 : r;
      p.push((cx + rr * Math.cos(a)).toFixed(1) + ',' + (cy + rr * Math.sin(a)).toFixed(1));
    }
    return '<polygon points="' + p.join(' ') + '" fill="' + fill + '" opacity="' + op + '"/>';
  }
  // Marguerite (repris du proof).
  function motifDaisy(cx, cy, s, pet, ctr) {
    var o = '';
    for (var i = 0; i < 6; i++) {
      var a = Math.PI / 3 * i;
      var ex = (cx + Math.cos(a) * s), ey = (cy + Math.sin(a) * s);
      o += '<ellipse cx="' + ex.toFixed(1) + '" cy="' + ey.toFixed(1) + '" rx="' + (s * 0.62).toFixed(1) +
           '" ry="' + (s * 0.34).toFixed(1) + '" fill="' + pet + '" transform="rotate(' +
           (a * 180 / Math.PI).toFixed(0) + ' ' + ex.toFixed(1) + ' ' + ey.toFixed(1) + ')" opacity="0.85"/>';
    }
    return o + '<circle cx="' + cx + '" cy="' + cy + '" r="' + (s * 0.5).toFixed(1) + '" fill="' + ctr + '"/>';
  }
  // Petit coeur centre en (cx,cy), taille s.
  function motifHeart(cx, cy, s, fill, op) {
    var d = 'M ' + cx.toFixed(1) + ' ' + (cy + s * 0.9).toFixed(1) +
      ' C ' + (cx - s * 1.1).toFixed(1) + ' ' + (cy - s * 0.1).toFixed(1) +
      ' ' + (cx - s * 0.55).toFixed(1) + ' ' + (cy - s * 0.95).toFixed(1) +
      ' ' + cx.toFixed(1) + ' ' + (cy - s * 0.35).toFixed(1) +
      ' C ' + (cx + s * 0.55).toFixed(1) + ' ' + (cy - s * 0.95).toFixed(1) +
      ' ' + (cx + s * 1.1).toFixed(1) + ' ' + (cy - s * 0.1).toFixed(1) +
      ' ' + cx.toFixed(1) + ' ' + (cy + s * 0.9).toFixed(1) + ' Z';
    return '<path d="' + d + '" fill="' + fill + '" opacity="' + op + '"/>';
  }
  // Un nuage = 3 cercles fusionnes + une base ellipse.
  function motifCloud(cx, cy, s, fill, op) {
    return '<g opacity="' + op + '" fill="' + fill + '">' +
      '<ellipse cx="' + cx.toFixed(1) + '" cy="' + (cy + s * 0.28).toFixed(1) + '" rx="' + (s * 1.5).toFixed(1) + '" ry="' + (s * 0.55).toFixed(1) + '"/>' +
      '<circle cx="' + (cx - s * 0.7).toFixed(1) + '" cy="' + cy.toFixed(1) + '" r="' + (s * 0.62).toFixed(1) + '"/>' +
      '<circle cx="' + cx.toFixed(1) + '" cy="' + (cy - s * 0.28).toFixed(1) + '" r="' + (s * 0.8).toFixed(1) + '"/>' +
      '<circle cx="' + (cx + s * 0.72).toFixed(1) + '" cy="' + cy.toFixed(1) + '" r="' + (s * 0.66).toFixed(1) + '"/>' +
      '</g>';
  }
  // Centres des 12 pictos (COLS x (ROWS-110), cf. generate-grids). Le motif se pose
  // AUTOUR de chaque picto (comme demandé), pas dans les marges globales.
  var MOTIF_PCX = [430, 1200, 1970], MOTIF_PCY = [820, 1390, 1960, 2530];
  // Scatter EN ANNEAU autour de chaque picto (dist 150-224). Évite le cône du bas
  // (secteur ~61°..119°) où se trouvent le libellé + la date.
  function motifScatter(id, perPicto, drawFn) {
    var prng = motifRng(id), o = '', k = 0;
    for (var r = 0; r < MOTIF_PCY.length; r++) {
      for (var c = 0; c < MOTIF_PCX.length; c++) {
        var cx = MOTIF_PCX[c], cy = MOTIF_PCY[r];
        for (var i = 0; i < perPicto; i++) {
          k++;
          var ang = prng() * Math.PI * 2;
          if (ang > Math.PI * 0.34 && ang < Math.PI * 0.66) ang += Math.PI;
          var dist = 150 + prng() * 74;
          var x = cx + Math.cos(ang) * dist, y = cy + Math.sin(ang) * dist * 0.9;
          o += drawFn(x, y, prng, k);
        }
      }
    }
    return o;
  }
  function motifLeaf(cx, cy, s, fill, op, ang) {
    return '<ellipse cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" rx="' + s.toFixed(1) + '" ry="' + (s * 0.45).toFixed(1) + '" fill="' + fill + '" opacity="' + op + '" transform="rotate(' + ang.toFixed(0) + ' ' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ')"/>';
  }
  var MOTIFS = {
    'none': function () { return ''; },
    'confetti': function (pal) {
      var cols = [pal.c1, pal.c2, pal.c4, pal.accent || pal.c2];
      return motifScatter('confetti', 7, function (x, y, prng, k) {
        if (prng() > 0.5) return '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (7 + prng() * 13).toFixed(1) + '" fill="' + cols[k % 4] + '" opacity="0.6"/>';
        return motifStar(x, y, 12, pal.c2, 0.7);
      });
    },
    'stars': function (pal) {
      return motifScatter('stars', 6, function (x, y, prng) {
        return motifStar(x, y, 9 + prng() * 15, (prng() > 0.5 ? pal.c2 : (pal.accent || pal.c1)), 0.6 + prng() * 0.3);
      });
    },
    'dots': function (pal) {
      var cols = [pal.c1, pal.c2, pal.c4, pal.accent || pal.c2];
      return motifScatter('dots', 8, function (x, y, prng, k) {
        return '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (7 + prng() * 11).toFixed(1) + '" fill="' + cols[k % 4] + '" opacity="0.5"/>';
      });
    },
    'flowers': function (pal) {
      return motifScatter('flowers', 5, function (x, y, prng) {
        return motifDaisy(x, y, 15 + prng() * 9, pal.c1, pal.c4);
      });
    },
    'hearts': function (pal) {
      return motifScatter('hearts', 6, function (x, y, prng) {
        return motifHeart(x, y, 11 + prng() * 10, (prng() > 0.5 ? pal.c1 : (pal.accent || pal.c2)), 0.55);
      });
    },
    'leaves': function (pal) {
      return motifScatter('leaves', 6, function (x, y, prng) {
        return motifLeaf(x, y, 15 + prng() * 9, pal.c2, 0.6, prng() * 360);
      });
    },
    'sparkles': function (pal) {
      return motifScatter('sparkles', 6, function (x, y, prng) {
        return motifStar(x, y, 8 + prng() * 11, (pal.accent || pal.c2), 0.6 + prng() * 0.3);
      });
    }
  };
  // Metadonnees d'affichage du selecteur "Fond" (ordre + libelle FR).
  var MOTIF_LIST = [
    { key: 'confetti', label: 'Confettis' },
    { key: 'stars',    label: 'Étoiles' },
    { key: 'dots',     label: 'Points' },
    { key: 'flowers',  label: 'Fleurs' },
    { key: 'hearts',   label: 'Cœurs' },
    { key: 'leaves',   label: 'Feuilles' },
    { key: 'sparkles', label: 'Éclats' }
  ];

  // ---------- GRID_BORDER : bordure pre-selectionnee par defaut, par produit ----------
  // = la bordure "cuite" dans le hero de chaque affiche (meme mapping que THEME_BORDER
  // cote generateur). Au chargement, on selectionne cette bordure (couleur "Assortie")
  // au lieu de "Aucune". Le client reste libre de changer ou de remettre "Aucune".
  var GRID_BORDER = {
    "affiche-premieres-fois":      "floral",
    "premieres-fois":              "floral",
    "affiche-premiere-annee":      "laurier",
    "affiche-premieres-fetes":     "fanions",
    "affiche-premieres-fois-2":    "pois",
    "affiche-bienvenue-bebe":      "nuages",
    "affiche-premieres-vacances":  "eucalyptus",
    "affiche-premieres-fois-grand":"geo",
    "affiche-annee-maternelle":    "celeste",
    "affiche-mes-exploits":        "torsade",
    "affiche-je-grandis":          "soleil",
    "affiche-premiers-a-la-maison":"coeurs",
    "affiche-notre-histoire":      "coeurs",
    "affiche-nos-voyages":         "eucalyptus",
    "affiche-nos-fetes":           "fanions",
    "affiche-mon-noel":            "celeste",
    "affiche-ma-grossesse":        "floral",
    "affiche-notre-maison":        "laurier",
    "affiche-parents":             "coeurs",
    "affiche-mamie-papy":          "floral",
    "affiche-annee-ecole":         "fanions",
    "affiche-vacances-mer":        "celeste",
    "affiche-fois-montagne":       "eucalyptus",
    "affiche-fois-gourmand":       "pois",
    "affiche-fois-artiste":        "torsade",
    "affiche-fois-nature":         "feuillage",
    "affiche-mes-voyages":         "nuages",
    "affiche-jour-bapteme":        "laurier",
    "affiche-jour-communion":      "floral",
    "affiche-fois-sport":          "fanions",
    "affiche-fois-jardin":         "feuillage",
    "affiche-mon-doudou":          "nuages",
    "affiche-premiere-rentree":    "pois",
    "affiche-fois-musique":        "liberty",
    "affiche-mon-cirque":          "fanions",
    "affiche-fois-piscine":        "celeste",
    "affiche-quatre-saisons":      "eucalyptus",
    "affiche-fois-copains":        "papillons",
    "affiche-fois-anniv":          "feston",
    "affiche-petit-chef":          "eucalyptus",
    "affiche-mes-jeux":            "pois",
    "affiche-fois-bricoleur":      "geo",
    "affiche-fois-ferme":          "fanions",
    "affiche-premiers-jours":      "nuages",
    "affiche-mes-nuits-bebe":      "celeste",
    "affiche-bienvenue-monde":     "floral",
    "affiche-ma-premiere-annee-saisons": "laurier",
    "affiche-notre-mariage":       "liberty",
    "affiche-nos-fiancailles":     "coeurs"
  };

  var handle = HSP_CFG.handle;
  // Libelles : metafield (frais, ecrit par l'outil admin a chaque regen) en
  // priorite, sinon GRIDS bake, sinon premieres-fois.
  var METAFIELD_LABELS = HSP_CFG.metafieldLabels;
  var MILESTONES = (METAFIELD_LABELS && METAFIELD_LABELS.length === 12)
    ? METAFIELD_LABELS
    : (GRIDS[handle] || GRIDS["premieres-fois"]);

  // Encre par defaut = ink de la palette hero (sauge). Lisible sur fonds clairs.
  var INK = (PALETTES[HERO_PALETTE] || {}).ink || "#3a352f";

  // ---------- Couleur du fond (couche LIBRE, independante de la palette) ----------
  // Teinte de la couche .hsp-bg-layer. Defaut = Creme. Modifiable via le selecteur
  // "Couleur du fond". Sert au cache des patches perso (curBg) + au fill des
  // placeholders dates + au panier (_hs_bg).
  var BG_DEFAULT = "#FBF6EE";
  var bgColor    = BG_DEFAULT;
  var bgName     = "Crème";

  // ---------- Map palette -> URL canvas (depuis product.images alt "canvas:*") ----------
  // Chaque visuel canvas SANS texte (2400 large, https:) est range par palette.
  // L'image featured = palette hero ; les pastilles permettent d'en changer.
  var CANVAS_BY_PALETTE = HSP_CFG.canvasByPalette;

  // URL absolue (https:) du canvas SANS texte par defaut = featured_image (2400 large).
  // Le Worker shopify-to-gelato rend directement le tableau _hs_grid par-dessus.
  var CANVAS_URL = CANVAS_BY_PALETTE[HERO_PALETTE] || HSP_CFG.canvasBaseUrl;

  // Palette par defaut : metafield happilystory.default_palette si dispo, sinon 'sauge'.
  var DEFAULT_PALETTE = HSP_CFG.defaultPalette;

  // Palette de l'affiche actuellement choisie (canvas + ink par defaut).
  // Priorite : metafield si un canvas existe pour cette palette, sinon sauge (hero),
  // sinon 1re palette disponible. Pre-selection appliquee au chargement (voir plus bas).
  var canvasPalette = null;
  (function initGridPalette() {
    if (CANVAS_BY_PALETTE[DEFAULT_PALETTE]) { canvasPalette = DEFAULT_PALETTE; }
    else if (CANVAS_BY_PALETTE[HERO_PALETTE]) { canvasPalette = HERO_PALETTE; }
    else {
      // Ordre local (PALETTE_ORDER est defini plus bas) : 1re palette disponible.
      var order = ['sauge', 'rose', 'bleu', 'terracotta', 'soleil', 'lavande', 'peche', 'lin'];
      for (var i = 0; i < order.length; i++) {
        if (CANVAS_BY_PALETTE[order[i]]) { canvasPalette = order[i]; break; }
      }
    }
  })();

  // Prenom d'echantillon par produit (handle).
  var SAMPLES_GRID = {};
  var samplePrenom = (SAMPLES_GRID[handle] || {}).prenom || 'Léon';

  // Tableau des variantes (Format x Cadre) genere en Liquid.
  var VARIANTS = HSP_CFG.variants;

  var form    = root.querySelector('.hsp-form');
  var overlay = root.querySelector('.hsp-overlay');

  // ---------- Construction de l'overlay : 1 prenom + 12 dates ----------
  var SVGNS = 'http://www.w3.org/2000/svg';
  function mkText(attrs) {
    var t = document.createElementNS(SVGNS, 'text');
    t.setAttribute('text-anchor', 'middle');
    t.setAttribute('dominant-baseline', 'alphabetic');
    Object.keys(attrs).forEach(function (k) { t.setAttribute(k, attrs[k]); });
    return t;
  }

  // 13 slots : index 'prenom' + 0..11. Chaque slot = { el, base (taille viewBox),
  // fitted (taille apres auto-fit), maxw (largeur de case) }.
  var slots = {};

  // Prenom : largeur utile large (texte centre en haut). Coords = LAYOUT.
  var prenomEl = mkText({
    'class': 'hsp-prenom',
    x: LAYOUT.prenom.x, y: LAYOUT.prenom.y,
    'font-family': "Caveat, cursive",
    'font-size': LAYOUT.prenom.size,
    'font-weight': 700,
    fill: INK
  });
  prenomEl.setAttribute('data-bind', 'prenom');
  overlay.appendChild(prenomEl);
  slots.prenom = { el: prenomEl, base: LAYOUT.prenom.size, fitted: LAYOUT.prenom.size, maxw: 1600 };

  // 12 dates : MAXW = largeur de case (~760, 3 colonnes sur 2400). Coords = LAYOUT.
  var DATE_MAXW = 760;
  for (var i = 0; i < 12; i++) {
    var d = LAYOUT.dates[i];
    var el = mkText({
      'class': 'hsp-grid-date',
      x: d.x, y: d.y,
      'font-family': "Caveat, cursive",
      'font-size': d.size,
      'font-weight': 700,
      fill: INK
    });
    el.setAttribute('data-grid-date', i);
    overlay.appendChild(el);
    slots[i] = { el: el, base: d.size, fitted: d.size, maxw: DATE_MAXW };
  }

  // Liste ordonnee pour iterer prenom + 0..11.
  var slotKeys = ['prenom'];
  for (var k = 0; k < 12; k++) slotKeys.push(k);

  // ---------- Signature happilystory (centre bas, retirable via toggle) ----------
  // Hors slots/auto-fit : police + graisse fixes, seul fill suit INK.
  var sigEl = mkText({
    'class': 'hsp-signature',
    x: LAYOUT.signature.x, y: LAYOUT.signature.y,
    'font-family': "Caveat, cursive",
    'font-size': LAYOUT.signature.size,
    'font-weight': 400,
    'letter-spacing': 10,
    opacity: 0.4,
    fill: INK
  });
  sigEl.setAttribute('data-bind', 'signature');
  sigEl.textContent = 'happilystory';
  overlay.appendChild(sigEl);

  // ---------- Police + taille du texte ----------
  var fontKey     = "caveat";
  var fontFamily  = "'Caveat', cursive";
  var printFamily = "Caveat";
  var fontScale   = 1;

  // ---------- Auto-fit : reduit la police si le texte deborde la largeur ----------
  // MAXW propre a chaque slot (prenom large, dates = largeur de case).
  // getComputedTextLength() renvoie la longueur dans les unites viewBox (2400),
  // directement comparable a maxw. Les tailles ajustees sont transmises au
  // panier (_hs_grid) pour que le Worker print rende exactement pareil.
  function fitSize(el, desiredPx, maxw) {
    el.style.fontSize = desiredPx + 'px';
    var len = el.getComputedTextLength ? el.getComputedTextLength() : 0;
    if (len > maxw && len > 0) {
      var s = Math.floor(desiredPx * maxw / len);
      el.style.fontSize = s + 'px';
      return s;
    }
    return desiredPx;
  }

  function applyFont() {
    slotKeys.forEach(function (key) {
      var s = slots[key];
      s.el.style.fontFamily = fontFamily;
      s.fitted = fitSize(s.el, s.base * fontScale, s.maxw);
    });
  }

  var fontBtns = form.querySelectorAll('.hsp-fontbtn');
  fontBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      fontKey     = btn.getAttribute('data-font');
      fontFamily  = btn.getAttribute('data-family');
      printFamily = btn.getAttribute('data-printfamily');
      fontBtns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      applyFont();
    });
  });

  var sizeBtns = form.querySelectorAll('.hsp-sizebtn');
  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      fontScale = parseFloat(btn.getAttribute('data-scale')) || 1;
      sizeBtns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      applyFont();
    });
  });

  // ---------- Palette couleur du texte (applique a TOUS les slots) ----------
  // Hooks de la personnalisation (assignes plus bas). Appeles ici de facon
  // defensive pour recolorer les pictos/labels patchees quand l'ink ou la
  // palette d'affiche changent, sans casser le flux si le module n'est pas pret.
  var hsPersoRecolor = null;     // recolorise pictos + cache + labels patchees
  var hsPersoRecolorInk = null;  // recolorise uniquement l'ink des labels patchees
  var hsBorderOnPaletteChange = null; // recolorise la bordure si couleur=Assortie
  var hsMotifOnPaletteChange = null;  // re-rend le motif de fond avec la nouvelle palette

  var inkName = 'Encre';
  var swatches = form.querySelectorAll('.hsp-swatch');
  function applyInk() {
    slotKeys.forEach(function (key) { slots[key].el.setAttribute('fill', INK); });
    if (sigEl) sigEl.setAttribute('fill', INK);
    if (hsPersoRecolorInk) hsPersoRecolorInk();
    // Restaure le fill clair des emplacements vierges (cases non datees, toggle ON),
    // que la boucle ci-dessus vient de repasser en INK. Ne s'execute qu'apres init
    // des champs date (render defini + dateInputs prets).
    if (typeof render === 'function' && dateInputs && dateInputs.length) render();
  }
  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      INK = sw.getAttribute('data-color');
      inkName = sw.getAttribute('data-name');
      applyInk();
      swatches.forEach(function (s) {
        var on = s === sw;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    });
  });
  applyInk();

  // ---------- Selecteur "Couleur de l'affiche" (canvas) ----------
  // Construit depuis CANVAS_BY_PALETTE (alt "canvas:*"). Au clic :
  //   (a) change la src de l'image de base .hsp-product-base vers l'URL palette,
  //   (b) pose INK = PALETTES[p].ink puis applyInk()/applyFont() (recolore overlay),
  //   (c) memorise la palette choisie (canvasPalette) pour le panier.
  // L'ink de la palette n'est qu'un DEFAUT : le swatch texte peut ensuite override.
  var baseImg     = root.querySelector('.hsp-product-base');
  var canvasPick  = form.querySelector('[data-canvaspick]');
  var canvasWrap  = canvasPick ? canvasPick.querySelector('.hsp-canvas-swatches') : null;
  // Pastilles de previsualisation des palettes (couleur dominante c2 du registry).
  var PALETTE_DOT = { sauge: '#8FAE93', rose: '#D98C9A', bleu: '#7FA3BC', terracotta: '#C2785C',
                      soleil: '#D6A94B', lavande: '#9C84C0', peche: '#E08E6E', lin: '#A89C85' };
  // Ordre d'affichage fixe : sauge en premier (= hero, actif par defaut).
  var PALETTE_ORDER = ['sauge', 'rose', 'bleu', 'terracotta', 'soleil', 'lavande', 'peche', 'lin'];

  function selectCanvasPalette(pal, btn) {
    var url = CANVAS_BY_PALETTE[pal];
    if (!url) return;
    canvasPalette = pal;
    CANVAS_URL = url;
    if (baseImg && baseImg.tagName === 'IMG') {
      baseImg.removeAttribute('srcset');
      baseImg.src = url;
    }
    // Ink par defaut de la palette ; resynchronise aussi le swatch texte "Encre".
    var pInk = (PALETTES[pal] || {}).ink;
    if (pInk) {
      INK = pInk;
      inkName = (PALETTES[pal] || {}).label || inkName;
      swatches.forEach(function (s) {
        var on = (s.getAttribute('data-color') || '').toLowerCase() === pInk.toLowerCase();
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
        if (on) inkName = s.getAttribute('data-name') || inkName;
      });
      applyInk();
      applyFont();
    }
    if (canvasWrap) {
      canvasWrap.querySelectorAll('.hsp-canvas-swatch').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    // La palette d'illustrations a change : recolore les pictos patchees + l'ink des
    // labels (le cache du fond suit bgColor, independant de la palette).
    if (hsPersoRecolor) hsPersoRecolor();
    // Si bordure active + couleur "Assortie" : recolorise selon la nouvelle palette (c2).
    if (hsBorderOnPaletteChange) hsBorderOnPaletteChange();
    // Si un motif de fond est choisi : re-rend avec les couleurs de la nouvelle palette.
    if (hsMotifOnPaletteChange) hsMotifOnPaletteChange();
  }

  if (canvasWrap) {
    var canvasPalettes = PALETTE_ORDER.filter(function (p) { return CANVAS_BY_PALETTE[p]; });
    // N'afficher le selecteur que s'il y a au moins 2 visuels canvas.
    if (canvasPalettes.length >= 2) {
      canvasPalettes.forEach(function (pal) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hsp-canvas-swatch' + (pal === canvasPalette ? ' is-active' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('data-palette', pal);
        b.setAttribute('aria-checked', pal === canvasPalette ? 'true' : 'false');
        b.style.setProperty('--cs', PALETTE_DOT[pal] || '#ccc');
        b.title = (PALETTES[pal] || {}).label || pal;
        b.setAttribute('aria-label', b.title);
        b.addEventListener('click', function () { selectCanvasPalette(pal, b); });
        canvasWrap.appendChild(b);
      });
      canvasPick.removeAttribute('hidden');
    }
  }

  // ---------- Selecteur "Couleur du fond" (couche libre) ----------
  // Au clic : bgColor = hex + repeint .hsp-bg-layer. Recolore aussi les caches des
  // patches perso (curBg) + le fill des placeholders dates (placeholderFill via render).
  // Hooks assignes plus bas (defensif : peuvent etre nuls si module pas pret).
  var bgLayer = root.querySelector('[data-bg-layer]');
  if (bgLayer) bgLayer.style.backgroundColor = bgColor;
  var bgSwatches = form.querySelectorAll('[data-bgpick] .hsp-swatch');
  bgSwatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      bgColor = sw.getAttribute('data-bg') || BG_DEFAULT;
      bgName  = sw.getAttribute('data-name') || bgName;
      if (bgLayer) bgLayer.style.backgroundColor = bgColor;
      bgSwatches.forEach(function (s) {
        var on = s === sw;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      // Le fond a change : repeint les caches des patches perso + re-rend les
      // placeholders dates (leur teinte claire interpole vers bgColor).
      if (hsPersoRecolor) hsPersoRecolor();
      if (typeof render === 'function' && dateInputs && dateInputs.length) render();
    });
  });

  // =====================================================================
  // BORDURE DECORATIVE (calque vivant, GRATUIT)
  // Selecteur de style (Aucune + 10) + couleur (Assortie=c2 ou custom).
  // Calque .hsp-border-layer entre l'image base et l'overlay texte.
  // =====================================================================
  (function () {
    var borderPick   = form.querySelector('[data-borderpick]');
    var vignettesWrap= borderPick ? borderPick.querySelector('.hsp-border-vignettes') : null;
    var colorBlock   = borderPick ? borderPick.querySelector('[data-bordercolor]') : null;
    var colorWrap    = colorBlock ? colorBlock.querySelector('.hsp-bordercolor-swatches') : null;
    var layer        = root.querySelector('[data-border-layer]');
    if (!borderPick || !vignettesWrap || !layer) return;

    // Cache de texte SVG (dedup des fetchs ; meme pattern que le module perso).
    var BORDER_SVG_CACHE = new Map();
    function fetchBorderSvg(url) {
      if (BORDER_SVG_CACHE.has(url)) return BORDER_SVG_CACHE.get(url);
      var p = fetch(url, { credentials: 'omit', cache: 'force-cache' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('svg ' + r.status)); })
        .then(function (txt) { var k = txt.indexOf('<svg'); return k >= 0 ? txt.slice(k) : txt; })
        .catch(function (e) { BORDER_SVG_CACHE.delete(url); throw e; });
      BORDER_SVG_CACHE.set(url, p);
      return p;
    }

    // ---------- Etat ----------
    var curBorder    = null;   // { key, label, url } ou null = Aucune
    var colorAuto    = true;   // true = "Assortie" (suit c2 de la palette d'affiche)
    var customColor  = null;   // hex custom si colorAuto=false
    var customName   = '';     // nom de la teinte custom (pour le panier)
    var renderToken  = 0;      // invalide les rendus de bordure obsoletes

    // Teinte "Assortie" = c2 de la palette d'affiche courante (teinte moyenne).
    function curPalette() {
      return (canvasPalette && PALETTES[canvasPalette]) ? canvasPalette : HERO_PALETTE;
    }
    function resolveColor() {
      if (!colorAuto && customColor) return customColor;
      return (PALETTES[curPalette()] || {}).c2 || '#6f8567';
    }

    // ---------- Calque live : inline + recolore la bordure ----------
    function paintLayer() {
      if (!curBorder) { layer.innerHTML = ''; return; }
      var token = ++renderToken;
      var color = resolveColor();
      fetchBorderSvg(curBorder.url).then(function (txt) {
        if (token !== renderToken) return; // un autre choix a pris le dessus
        var wrap = document.createElement('span');
        wrap.innerHTML = txt;
        var svg = wrap.querySelector('svg');
        if (!svg) { layer.innerHTML = ''; return; }
        svg.removeAttribute('width'); svg.removeAttribute('height');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        layer.innerHTML = '';
        layer.style.color = color;   // les SVG utilisent currentColor
        layer.appendChild(svg);
      }).catch(function () { /* echec silencieux : calque vide */ });
    }

    // Recolore sans refetch (changement de couleur ou de palette quand Assortie).
    function recolorLayer() {
      if (!curBorder) return;
      layer.style.color = resolveColor();
    }

    // Hook appele depuis selectCanvasPalette : recolore si "Assortie".
    hsBorderOnPaletteChange = function () { if (colorAuto) recolorLayer(); };

    // ---------- Vignettes : "Aucune" (deja en markup) + 10 styles ----------
    var noneBtn = vignettesWrap.querySelector('.hsp-border-vignette--none');
    function setActiveVignette(btn) {
      vignettesWrap.querySelectorAll('.hsp-border-vignette').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    function selectBorder(def, btn) {
      curBorder = def; // null pour Aucune
      setActiveVignette(btn);
      if (colorBlock) { if (def) colorBlock.removeAttribute('hidden'); else colorBlock.setAttribute('hidden', ''); }
      paintLayer();
    }
    if (noneBtn) noneBtn.addEventListener('click', function () { selectBorder(null, noneBtn); });

    BORDERS.forEach(function (def) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hsp-border-vignette';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('data-border-key', def.key);
      btn.title = def.label;
      btn.setAttribute('aria-label', 'Bordure ' + def.label);
      vignettesWrap.appendChild(btn);
      // Mini-apercu : ZOOM sur le coin haut-gauche de la bordure (viewBox recadre)
      // pour que le motif (pois, feston, floral...) soit gros et lisible dans la
      // pastille — le cadre entier reduit rendait les traits invisibles.
      fetchBorderSvg(def.url).then(function (txt) {
        var wrap = document.createElement('span');
        wrap.innerHTML = txt;
        var svg = wrap.querySelector('svg');
        if (!svg) return;
        svg.removeAttribute('width'); svg.removeAttribute('height');
        svg.setAttribute('viewBox', '0 0 500 645');   // coin haut-gauche zoome (~5x)
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        btn.innerHTML = '';
        btn.style.color = (PALETTES[curPalette()] || {}).c2 || '#6f8567';
        btn.appendChild(svg);
      }).catch(function () { /* garde le bouton vide en cas d'echec */ });
      btn.addEventListener('click', function () { selectBorder(def, btn); });
    });

    // ---------- Couleur de la bordure : "Assortie" + pastilles custom ----------
    var autoBtn   = colorWrap ? colorWrap.querySelector('[data-bordercolor-auto]') : null;
    var colorSws  = colorWrap ? colorWrap.querySelectorAll('.hsp-bordercolor-swatch') : [];
    function setActiveColor(activeEl) {
      if (autoBtn) {
        var aOn = activeEl === autoBtn;
        autoBtn.classList.toggle('is-active', aOn);
        autoBtn.setAttribute('aria-checked', aOn ? 'true' : 'false');
      }
      colorSws.forEach(function (s) {
        var on = s === activeEl;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    if (autoBtn) autoBtn.addEventListener('click', function () {
      colorAuto = true; customColor = null; customName = '';
      setActiveColor(autoBtn);
      recolorLayer();
    });
    colorSws.forEach(function (sw) {
      sw.addEventListener('click', function () {
        colorAuto = false;
        customColor = sw.getAttribute('data-bordercolor-val');
        customName = sw.getAttribute('data-bordercolor-name') || '';
        setActiveColor(sw);
        recolorLayer();
      });
    });

    // ---------- Expose au submit : payload bordure ----------
    // Renvoie toujours sig_y (3035) ; url/color/labels uniquement si bordure != Aucune.
    window.__hsBuildBorderPayload = function () {
      var out = { sigY: LAYOUT.signature.y }; // 3035 en permanence (coherence worker)
      if (curBorder) {
        out.url   = curBorder.url;
        out.color = resolveColor();
        out.label = curBorder.label;
        out.colorName = colorAuto
          ? ('Assortie (' + ((PALETTES[curPalette()] || {}).label || curPalette()) + ')')
          : (customName || resolveColor());
      }
      return out;
    };

    // ---------- Pre-selection au CHARGEMENT : bordure par defaut du produit ----------
    // GRID_BORDER[handle] => on selectionne cette bordure (couleur "Assortie" par defaut,
    // colorAuto=true). Reutilise selectBorder() : vignette active + colorBlock visible +
    // calque .hsp-border-layer rempli + curBorder pose => le panier l'envoie par defaut.
    // Le client peut changer ou cliquer "Aucune" (curBorder=null => rien envoye).
    (function preselectDefaultBorder() {
      var key = GRID_BORDER[handle];
      if (!key) return; // pas de defaut pour ce produit -> reste "Aucune"
      var def = null;
      for (var i = 0; i < BORDERS.length; i++) { if (BORDERS[i].key === key) { def = BORDERS[i]; break; } }
      if (!def) return;
      var btn = vignettesWrap.querySelector('.hsp-border-vignette[data-border-key="' + key + '"]');
      if (!btn) return;
      selectBorder(def, btn);
    })();
  })();

  // =====================================================================
  // FOND MOTIF (calque decoratif, GRATUIT)
  // Selecteur (Aucun + 7 motifs) -> re-rend .hsp-motif-layer avec MOTIFS[id](pal).
  // Recolore quand la palette d'illustrations change. Envoye au panier (_hs_motif).
  // =====================================================================
  (function () {
    var motifPick     = form.querySelector('[data-motifpick]');
    var vignettesWrap = motifPick ? motifPick.querySelector('.hsp-motif-vignettes') : null;
    var layer         = root.querySelector('[data-motif-layer]');
    if (!motifPick || !vignettesWrap || !layer) return;

    var curMotif = 'none';   // id du motif courant (defaut : aucun)

    // Palette d'illustrations courante (memes couleurs que les pictos).
    function curPal() {
      return PALETTES[(canvasPalette && PALETTES[canvasPalette]) ? canvasPalette : HERO_PALETTE] || PALETTES[HERO_PALETTE];
    }
    // Construit un SVG plein cadre a partir de l'inner genere par MOTIFS[id].
    function buildMotifSvg(id, pal) {
      var fn = MOTIFS[id];
      if (!fn || id === 'none') return '';
      var inner = '';
      try { inner = fn(pal) || ''; } catch (e) { inner = ''; }
      if (!inner) return '';
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + MOTIF_W + ' ' + MOTIF_H +
        '" preserveAspectRatio="xMidYMid meet" aria-hidden="true">' + inner + '</svg>';
    }
    // Vignette "echantillon" DENSE (viewBox 106x132) : quelques elements gros +
    // contrastes qui remplissent la pastille -> le client voit clairement le motif
    // choisi (le rendu reel sur l'affiche reste disperse/doux). Memes couleurs que la
    // palette. Le fond de la pastille = --mv-bg (CSS), donc pas de <rect> ici.
    var MOTIF_SWATCH_PTS = [[28, 32], [64, 26], [86, 56], [24, 64], [56, 60], [82, 92], [40, 106]];
    function motifSwatchInner(id, pal) {
      var cols = [pal.c1, pal.c2, pal.c4, pal.accent || pal.c2], o = '';
      for (var i = 0; i < MOTIF_SWATCH_PTS.length; i++) {
        var x = MOTIF_SWATCH_PTS[i][0], y = MOTIF_SWATCH_PTS[i][1];
        if (id === 'confetti') o += (i % 3 === 0) ? motifStar(x, y, 10, pal.c2, 0.92) : '<circle cx="' + x + '" cy="' + y + '" r="' + (7 + (i % 3) * 1.5).toFixed(1) + '" fill="' + cols[i % 4] + '" opacity="0.9"/>';
        else if (id === 'stars') o += motifStar(x, y, 11, (i % 2 ? pal.c2 : (pal.accent || pal.c1)), 0.92);
        else if (id === 'dots') o += '<circle cx="' + x + '" cy="' + y + '" r="' + (7 + (i % 3)).toFixed(1) + '" fill="' + cols[i % 4] + '" opacity="0.88"/>';
        else if (id === 'flowers') { if (i % 2 === 0 || i === 3) o += motifDaisy(x, y, 12, pal.c1, pal.c4); }
        else if (id === 'hearts') o += motifHeart(x, y, 10, (i % 2 ? pal.c1 : (pal.accent || pal.c2)), 0.9);
        else if (id === 'leaves') o += motifLeaf(x, y, 13, pal.c2, 0.9, i * 44);
        else if (id === 'sparkles') o += motifStar(x, y, 10, (pal.accent || pal.c2), 0.92);
      }
      return o;
    }
    function buildMotifSwatch(id, pal) {
      if (!id || id === 'none') return '';
      var inner = motifSwatchInner(id, pal);
      if (!inner) return '';
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106 132" preserveAspectRatio="xMidYMid meet" aria-hidden="true">' + inner + '</svg>';
    }
    // (Re)peint la couche avec le motif courant + la palette courante.
    function paintLayer() {
      layer.innerHTML = buildMotifSvg(curMotif, curPal());
    }
    // Refs des vignettes Fond (pour les recolorer quand la palette d'illus change).
    var motifVigBtns = [];
    // Hook appele depuis selectCanvasPalette : re-rend la couche + recolore les vignettes.
    hsMotifOnPaletteChange = function () {
      paintLayer();
      var p = curPal();
      motifVigBtns.forEach(function (v) {
        v.btn.style.setProperty('--mv-bg', (p || {}).bg || '#FBF6EE');
        v.btn.innerHTML = buildMotifSwatch(v.key, p);
      });
    };

    function setActiveVignette(btn) {
      vignettesWrap.querySelectorAll('.hsp-motif-vignette').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    function selectMotif(id, btn) {
      curMotif = id || 'none';
      setActiveVignette(btn);
      paintLayer();
    }

    // "Aucun" (deja en markup) : vide la couche.
    var noneBtn = vignettesWrap.querySelector('.hsp-motif-vignette--none');
    if (noneBtn) noneBtn.addEventListener('click', function () { selectMotif('none', noneBtn); });

    // 7 motifs : bouton + echantillon dense LISIBLE (recolore avec la palette).
    MOTIF_LIST.forEach(function (def) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hsp-motif-vignette';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('data-motif-key', def.key);
      btn.title = def.label;
      btn.setAttribute('aria-label', 'Fond ' + def.label);
      // Mini-apercu : echantillon dense recolore sur un fond creme (via --mv-bg).
      btn.style.setProperty('--mv-bg', (curPal() || {}).bg || '#FBF6EE');
      btn.innerHTML = buildMotifSwatch(def.key, curPal());
      btn.addEventListener('click', function () { selectMotif(def.key, btn); });
      vignettesWrap.appendChild(btn);
      motifVigBtns.push({ btn: btn, key: def.key });
    });

    // Expose au submit : id du motif + label (si != Aucun).
    window.__hsBuildMotifPayload = function () {
      if (!curMotif || curMotif === 'none') return { id: 'none' };
      var found = null;
      for (var i = 0; i < MOTIF_LIST.length; i++) { if (MOTIF_LIST[i].key === curMotif) { found = MOTIF_LIST[i]; break; } }
      return { id: curMotif, label: found ? found.label : curMotif };
    };
  })();

  // ---------- Format date FR court : "12.03.2024" ----------
  function fmtDate(val) {
    if (!val) return '';
    // input type=date => "YYYY-MM-DD"
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(val);
    if (!m) return '';
    return m[3] + '.' + m[2] + '.' + m[1];
  }

  // ---------- Emplacement de date vierge (a completer au stylo) ----------
  // PAS de tirets : juste les barres "/" avec des espaces ecrivables (jj / mm / aaaa).
  // On utilise des espaces "chasse de chiffre" U+2007 (largeur d'un chiffre, NON
  // fusionnes par le rendu SVG, contrairement aux espaces normaux) -> gabarit a remplir.
  // handDates = ON (par defaut OFF). Par-cellule : n'est rendu QUE si la case
  // n'a pas de date renseignee ET que le toggle est actif.
  var handDates = false;
  var FIGSP=String.fromCharCode(0x2007),SL=String.fromCharCode(0x2F);var HAND_PLACEHOLDER=FIGSP+FIGSP+FIGSP+SL+FIGSP+FIGSP+FIGSP+SL+FIGSP+FIGSP+FIGSP+FIGSP+FIGSP;

  // Teinte de l'emplacement vierge : melange de l'INK courant vers la couleur
  // de FOND choisie (bgColor) pour un rendu plus clair/discret que la vraie encre.
  function lightenHex(hex, amount) {
    var m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    if (!m) return hex || '#9a958c';
    var n = parseInt(m[1], 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    var t = (typeof amount === 'number') ? amount : 0.55;
    // Cible = couleur de fond choisie (couche libre, independante de la palette).
    var bgHex = bgColor || '#ffffff';
    var bm = /^#?([0-9a-f]{6})$/i.exec(bgHex);
    var br = 255, bgc = 255, bb = 255;
    if (bm) { var bn = parseInt(bm[1], 16); br = (bn >> 16) & 255; bgc = (bn >> 8) & 255; bb = bn & 255; }
    r = Math.round(r + (br - r) * t);
    g = Math.round(g + (bgc - g) * t);
    b = Math.round(b + (bb - b) * t);
    function h2(v) { return ('0' + v.toString(16)).slice(-2); }
    return '#' + h2(r) + h2(g) + h2(b);
  }
  // Fill clair courant de l'emplacement vierge (recalcule a chaque render).
  function placeholderFill() { return lightenHex(INK, 0.58); }

  // ---------- Champs du formulaire ----------
  var inputPrenom = form.querySelector('[data-source="prenom"]');
  var dateInputs  = [];
  for (var di = 0; di < 12; di++) {
    dateInputs[di] = form.querySelector('[data-grid-input="' + di + '"]');
  }

  function render() {
    var prenom = (inputPrenom ? inputPrenom.value : '').trim();
    slots.prenom.el.textContent = prenom || samplePrenom;
    var phFill = placeholderFill();
    for (var j = 0; j < 12; j++) {
      var raw = dateInputs[j] ? dateInputs[j].value : '';
      var fr = fmtDate(raw);
      // Par-cellule : date renseignee => date (encre) ; sinon si toggle ON =>
      // emplacement vierge (teinte plus claire) ; sinon rien.
      if (fr) {
        slots[j].el.textContent = fr;
        slots[j].el.setAttribute('fill', INK);
      } else if (handDates) {
        slots[j].el.textContent = HAND_PLACEHOLDER;
        slots[j].el.setAttribute('fill', phFill);
      } else {
        slots[j].el.textContent = '';
        slots[j].el.setAttribute('fill', INK);
      }
    }
    // Le fit depend du texte courant => refit apres chaque maj du textContent.
    applyFont();
  }

  // Etat initial : prenom = echantillon, dates vides.
  slots.prenom.el.textContent = samplePrenom;
  applyFont();

  // ---------- Pre-selection de la palette par defaut (metafield) au CHARGEMENT ----------
  // Applique la palette par defaut (swap image de base + ink) APRES que applyFont soit
  // defini (selectCanvasPalette appelle applyFont). Le canvas affiche par defaut est le
  // hero (sauge) : si la palette par defaut differe, on swappe vers son canvas + ink.
  // Le selecteur pointe deja la bonne pastille (is-active === canvasPalette).
  if (canvasWrap && canvasPalette && CANVAS_BY_PALETTE[canvasPalette]) {
    var defPalBtn = canvasWrap.querySelector('.hsp-canvas-swatch.is-active');
    selectCanvasPalette(canvasPalette, defPalBtn);
  }

  ['input', 'change'].forEach(function (ev) {
    if (inputPrenom) inputPrenom.addEventListener(ev, render);
    dateInputs.forEach(function (inp) { if (inp) inp.addEventListener(ev, render); });
  });

  render();

  // ---------- Toggle "Laisser des cases a remplir a la main" ----------
  // ON => les cases non datees affichent un emplacement vierge (teinte claire).
  // Etat par-cellule gere dans render() ; ici on bascule juste le flag + re-rend.
  var handDatesBtn = form.querySelector('[data-handdates-btn]');
  if (handDatesBtn) {
    handDatesBtn.addEventListener('click', function () {
      handDates = !handDates;
      handDatesBtn.setAttribute('aria-pressed', handDates ? 'true' : 'false');
      render();
    });
  }

  // Les Google Fonts arrivent en differe (FOUT) : re-rend une fois pretes.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { render(); });
  }

  // ---------- Variantes (Format x Cadre) ----------
  var hiddenVariant = form.querySelector('[data-variant-id]');
  var priceNowEl    = root.querySelector('[data-price-now]');
  var btnTotalEl    = form.querySelector('[data-btn-total]');
  var addBtn        = form.querySelector('.hsp-add-to-cart');

  // ---------- Toggle : retirer la signature happilystory ----------
  var noWatermark = false;
  var watermarkBtn = form.querySelector('[data-watermark-btn]');
  function applyWatermark() {
    if (sigEl) sigEl.style.display = noWatermark ? 'none' : '';
    if (watermarkBtn) watermarkBtn.setAttribute('aria-pressed', noWatermark ? 'true' : 'false');
  }
  if (watermarkBtn) {
    watermarkBtn.addEventListener('click', function () {
      noWatermark = !noWatermark;
      applyWatermark();
      updateTotal();
    });
  }
  applyWatermark();

  var sel = { 1: null, 2: null };
  form.querySelectorAll('.hsp-chip.is-active').forEach(function (chip) {
    sel[chip.getAttribute('data-opt')] = chip.getAttribute('data-value');
  });
  // Dernier format PAPIER choisi : en mode numérique, sel['1'] vaut '__digital__'
  // et ne peut pas servir à croiser les prix du groupe Cadre.
  var lastPaperFormat = sel['1'];

  // ---------- Mockup cadre sur l'apercu (option2 = Cadre) ----------
  var frameEl = root.querySelector('[data-frame]');
  function cadreToState(label) {
    var v = (label || '').toLowerCase();
    if (v.indexOf('noir') !== -1) return 'noir';
    if (v.indexOf('bois') !== -1) return 'bois';
    return 'none';
  }
  function applyFrame() {
    if (frameEl) frameEl.setAttribute('data-cadre', window.hsDigitalMode ? 'none' : cadreToState(sel['2']));
  }
  applyFrame();

  var variantId = HSP_CFG.variantId;
  var variantPriceCents = HSP_CFG.variantPriceCents;

  // ---------- Gamme digitale (4e puce Format = fichier numérique HD) ----------
  // Config injectée par le snippet upsells (window.HAPPILYSTORY_DIGITAL =
  // { variantId, priceCents }). Sans config, la puce reste cachée.
  var DIGITAL = window.HAPPILYSTORY_DIGITAL || null;
  var digitalChip = form.querySelector('[data-digital-chip]');
  if (DIGITAL && digitalChip) digitalChip.hidden = false;
  function isDigitalMode() { return sel['1'] === '__digital__'; }
  function applyDigitalUi() {
    window.hsDigitalMode = isDigitalMode();
    // Le choix Cadre n'a pas de sens pour un fichier : groupe masqué + mockup nu.
    var cadreGroup = form.querySelector('.hsp-variant-group[data-option-index="2"]');
    if (cadreGroup) cadreGroup.style.display = window.hsDigitalMode ? 'none' : '';
    applyFrame();
    // Upsells sans objet en mode numérique : copie 5,99 € (redondante), réplique
    // papier et carte message (part dans le colis — pas de colis en numérique).
    // Masqués ET désélectionnés (sinon comptés au total / au panier).
    document.querySelectorAll('.hs-upsell[data-key="digital"], .hs-upsell[data-key="replique"], .hs-upsell[data-key="carte"]').forEach(function (card) {
      card.style.display = window.hsDigitalMode ? 'none' : '';
      if (window.hsDigitalMode && card.classList.contains('is-selected')) {
        card.classList.remove('is-selected');
        card.querySelectorAll('.hs-upsell__pill').forEach(function (p) {
          var isNo = p.getAttribute('data-choice') === 'no';
          p.classList.toggle('is-active', isNo);
          p.setAttribute('aria-pressed', isNo ? 'true' : 'false');
        });
        var ex = card.querySelector('[data-extra-for]');
        if (ex) ex.hidden = true;
      }
    });
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function findVariant() {
    var fmt = sel['1'], cad = sel['2'];
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      var okF = (fmt == null) || (v.format === fmt);
      var okC = (cad == null) || (v.cadre === cad);
      if (okF && okC) return v;
    }
    return null;
  }

  function upsellsTotalCents() {
    var sum = 0;
    document.querySelectorAll('.hs-upsell.is-selected').forEach(function (card) {
      var p = parseFloat(card.getAttribute('data-price'));
      if (!isNaN(p)) sum += Math.round(p * 100);
    });
    return sum;
  }

  // Renvoie true si au moins une case est personnalisee (assigne par le module perso).
  var hsPersoActive = function () { return false; };

  function updateTotal() {
    var total = variantPriceCents + upsellsTotalCents();
    if (noWatermark) total += WATERMARK_PRICE_CENTS;
    if (hsPersoActive()) total += PERSO_PRICE_CENTS;
    if (btnTotalEl) btnTotalEl.textContent = money(total);
  }

  function applyVariant() {
    // Mode numérique : la variante devient celle du produit digital standalone.
    if (isDigitalMode() && DIGITAL) {
      variantId = DIGITAL.variantId;
      variantPriceCents = DIGITAL.priceCents;
      if (hiddenVariant) hiddenVariant.value = DIGITAL.variantId;
      if (priceNowEl) priceNowEl.textContent = money(DIGITAL.priceCents);
      updateTotal();
      return;
    }
    var v = findVariant();
    if (v) {
      variantId = v.id;
      variantPriceCents = v.price;
      if (hiddenVariant) hiddenVariant.value = v.id;
      if (priceNowEl) priceNowEl.textContent = money(v.price);
    }
    updateTotal();
  }

  // Sous-prix des puces : prix TOTAL de la variante croisée — chaque puce Format
  // affiche « ce format × cadre sélectionné », chaque puce Cadre « format
  // sélectionné × ce cadre » (pattern sportsndeco, recroisé à chaque clic).
  function refreshChipPrices() {
    form.querySelectorAll('.hsp-chip').forEach(function (chip) {
      var priceEl = chip.querySelector('.hsp-chip__price');
      if (!priceEl) return;
      var val = chip.getAttribute('data-value');
      if (val === '__digital__') {
        if (DIGITAL) priceEl.textContent = money(DIGITAL.priceCents);
        return;
      }
      var isFormat = chip.getAttribute('data-opt') === '1';
      var fmt = isFormat ? val : (lastPaperFormat || sel['1']);
      var cad = isFormat ? sel['2'] : val;
      for (var i = 0; i < VARIANTS.length; i++) {
        var v = VARIANTS[i];
        if ((fmt == null || v.format === fmt) && (cad == null || v.cadre === cad)) {
          priceEl.textContent = money(v.price);
          return;
        }
      }
    });
  }

  form.querySelectorAll('.hsp-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var opt = chip.getAttribute('data-opt');
      var val = chip.getAttribute('data-value');
      sel[opt] = val;
      if (opt === '1' && val !== '__digital__') lastPaperFormat = val;
      chip.closest('.hsp-chips').querySelectorAll('.hsp-chip').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      applyVariant();
      refreshChipPrices();
      if (opt === '1') applyDigitalUi(); // bascule mode numérique <-> papier
      if (opt === '2') applyFrame();
    });
  });
  refreshChipPrices();

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.hs-upsell__pill')) {
      setTimeout(updateTotal, 0);
    }
  });

  updateTotal();

  // =====================================================================
  // PERSONNALISATION DES ILLUSTRATIONS (patch payant +5,99 €)
  // Le client clique une case -> picker (recherche manifest premium) ->
  // choisit un picto + edite l'intitule -> on repeint la case via un cache
  // (couleur de fond bgColor) + picto inline recolore + label, dans <g data-patch="i">.
  // =====================================================================
  (function () {
    // ---------- Constantes perso (declarees ICI, scope interne robuste) ----------
    // Variante du produit cache "upsell-perso-illustrations" (resolu en Liquid) +
    // manifest premium (~545 pictos). Places dans cet IIFE pour que le builder et
    // loadManifest les trouvent meme si le <script> de section est resegmente au runtime.

    var PERSO_VARIANT_ID = HSP_CFG.persoVariantId;
    var PREMIUM_MANIFEST_URL = HSP_CFG.premiumManifestUrl;

    // ---------- GEOMETRIE des 12 cases (viewBox 2400x3200, = canvas cuit) ----------
    var COLS = [430, 1200, 1970];
    var ROWS = [930, 1500, 2070, 2640];

    // cellGeom(i) -> boites picto / label / cache pour la case i (col=i%3, row=floor(i/3)).
    function cellGeom(i) {
      var col = i % 3, row = Math.floor(i / 3);
      var colX = COLS[col], cy = ROWS[row];
      return {
        picto: { cx: colX, cy: cy - 110, size: 320 },
        label: { x: colX, y: cy + 70, size: 58 },
        // Cache (cover) : repeint la case SANS toucher filet (cy+115) ni date (cy+225).
        // Bas du cache = cy+100, reste au-dessus du filet.
        cover: { x: colX - 205, y: cy - 300, w: 410, h: 400, rx: 24 }
      };
    }

    // ---------- ETAT : patches[i] = { pictoUrl, label } (vide = canvas cuit intact) ----------
    var patches = {};
    function patchKeys() { return Object.keys(patches); }
    function persoActive() { return patchKeys().length > 0; }

    // ---------- Couleur de fond courante (cache) = couche libre bgColor ----------
    // curPalette() reste la palette d'ILLUSTRATIONS (pictos/encre). Le FOND est
    // desormais independant : curBg() suit la couleur de fond choisie (bgColor).
    function curPalette() {
      return (canvasPalette && PALETTES[canvasPalette]) ? canvasPalette : HERO_PALETTE;
    }
    function curBg() { return bgColor || '#FBF6EE'; }

    // ---------- Cache module-level : texte SVG distant (dedup des fetchs) ----------
    var SVG_CACHE = new Map();
    function fetchSvgText(url) {
      if (SVG_CACHE.has(url)) return SVG_CACHE.get(url);
      var p = fetch(url, { credentials: 'omit', cache: 'force-cache' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('svg ' + r.status)); })
        .then(function (txt) { var k = txt.indexOf('<svg'); return k >= 0 ? txt.slice(k) : txt; })
        .catch(function (e) { SVG_CACHE.delete(url); throw e; });
      SVG_CACHE.set(url, p);
      return p;
    }

    // Applique les variables palette (--c1..--c6 + color) a un element conteneur,
    // pour recolorer les SVG inline qui utilisent var(--cN) / currentColor.
    function applyPaletteVars(el, pal) {
      var P = PALETTES[pal] || {};
      el.style.setProperty('--c1', P.c1 || '#8FAE93');
      el.style.setProperty('--c2', P.c2 || '#6F8567');
      el.style.setProperty('--c3', P.c3 || '#C9D8C2');
      el.style.setProperty('--c4', P.c4 || '#4A3B3F');
      el.style.setProperty('--c5', P.c5 || '#C2785C');
      el.style.setProperty('--c6', P.c6 || '#3A352F');
      el.style.setProperty('color', P.c1 || '#8FAE93');
    }

    // ---------- MANIFEST : chargement + index { all:[{id,category,cdnUrl,title,kw}] } ----------
    var manifestItems = null;     // tableau plat (lazy)
    var manifestPromise = null;
    var CAT_LABELS = {
      naissance: 'Naissance', bapteme: 'Baptême', maman: 'Maman', papa: 'Papa',
      mamie: 'Mamie', papy: 'Papy', saisons: 'Saisons', anniversaire: 'Anniversaire',
      noel: 'Noël', voyage: 'Voyage', dinosaures: 'Dinosaures', avions: 'Avions',
      voitures: 'Voitures', espace: 'Espace', licornes: 'Licornes', chateaux: 'Châteaux',
      bateaux: 'Bateaux', loisirs: 'Loisirs créatifs', bebe: 'Bébé'
    };
    function prettify(name) {
      var s = String(name || '').replace(/[_-]+/g, ' ').trim();
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
    function loadManifest() {
      if (manifestItems) return Promise.resolve(manifestItems);
      if (manifestPromise) return manifestPromise;
      manifestPromise = fetch(PREMIUM_MANIFEST_URL, { credentials: 'same-origin', cache: 'force-cache' })
        .then(function (r) { if (!r.ok) throw new Error('manifest ' + r.status); return r.json(); })
        .then(function (data) {
          var all = [];
          var themes = (data && data.themes) || {};
          Object.keys(themes).forEach(function (cat) {
            var pieces = (themes[cat] && themes[cat].pieces) || [];
            var catLabel = CAT_LABELS[cat] || cat;
            pieces.forEach(function (pc) {
              if (!pc || !pc.cdnUrl) return;
              var title = prettify(pc.name);
              all.push({
                id: cat + '__' + (pc.name || ''),
                category: cat,
                cdnUrl: pc.cdnUrl,
                title: title,
                // mots-cles FR pour la recherche : nom + titre + libelle de categorie + kw custom (pc.kw)
                kw: ((pc.name || '') + ' ' + title + ' ' + catLabel + ' ' + (pc.kw || '')).toLowerCase()
              });
            });
          });
          manifestItems = all;
          return all;
        });
      return manifestPromise;
    }

    // ---------- OVERLAY : zones cliquables (12 rects transparents + indice crayon) ----------
    // Couche dediee inseree AVANT prenom/dates/signature pour rester au-dessus du canvas
    // sans masquer le prenom (qui reste cliquable seulement via ses propres handlers).
    var zonesG = document.createElementNS(SVGNS, 'g');
    zonesG.setAttribute('data-cellzones', '');
    overlay.appendChild(zonesG);

    function buildZones() {
      for (var i = 0; i < 12; i++) {
        (function (idx) {
          var g = cellGeom(idx);
          var zg = document.createElementNS(SVGNS, 'g');
          zg.setAttribute('class', 'hsp-cellzone');
          zg.setAttribute('data-cell', idx);
          // Zone cliquable = boite picto + label (du haut du cache au label).
          var rect = document.createElementNS(SVGNS, 'rect');
          rect.setAttribute('x', g.cover.x);
          rect.setAttribute('y', g.cover.y);
          rect.setAttribute('width', g.cover.w);
          rect.setAttribute('height', g.cover.h);
          rect.setAttribute('rx', g.cover.rx);
          rect.setAttribute('fill', 'transparent');
          zg.appendChild(rect);
          // Indice "crayon" en coin haut-droit de la case (visible au survol via CSS).
          var hint = document.createElementNS(SVGNS, 'g');
          hint.setAttribute('class', 'hsp-cellzone__hint');
          var hx = g.cover.x + g.cover.w - 58, hy = g.cover.y + 14;
          var bg = document.createElementNS(SVGNS, 'circle');
          bg.setAttribute('cx', hx + 22); bg.setAttribute('cy', hy + 22); bg.setAttribute('r', 26);
          bg.setAttribute('fill', '#6F8567');
          hint.appendChild(bg);
          var pencil = document.createElementNS(SVGNS, 'path');
          pencil.setAttribute('d', 'M' + (hx + 14) + ' ' + (hy + 30) +
            ' L' + (hx + 26) + ' ' + (hy + 18) +
            ' L' + (hx + 30) + ' ' + (hy + 22) +
            ' L' + (hx + 18) + ' ' + (hy + 34) + ' Z');
          pencil.setAttribute('fill', '#fff');
          hint.appendChild(pencil);
          zg.appendChild(hint);
          zg.addEventListener('click', function () { openPicker(idx); });
          zonesG.appendChild(zg);
        })(i);
      }
    }
    buildZones();

    // ---------- PATCH OVERLAY : <g data-patch="i"> (cache + picto + label) ----------
    // Insere APRES les zones mais on garde prenom/dates/signature au-dessus :
    // on re-append ces derniers a chaque patch pour qu'ils restent visibles.
    function liftTopLayers() {
      // Remonte prenom + dates + signature au-dessus des patches.
      slotKeys.forEach(function (key) { if (slots[key]) overlay.appendChild(slots[key].el); });
      if (sigEl) overlay.appendChild(sigEl);
    }

    function patchGroup(i) {
      return overlay.querySelector('g[data-patch="' + i + '"]');
    }

    // Re-rend (ou cree) le patch de la case i depuis patches[i] + palette courante.
    function renderPatch(i) {
      var data = patches[i];
      var existing = patchGroup(i);
      if (existing) existing.parentNode.removeChild(existing);
      if (!data) { liftTopLayers(); return; }

      var g = cellGeom(i);
      var pal = curPalette();
      var grp = document.createElementNS(SVGNS, 'g');
      grp.setAttribute('data-patch', i);
      applyPaletteVars(grp, pal);

      // (a) Cache : repeint la case (fill = bg de la palette), arrondi.
      var cover = document.createElementNS(SVGNS, 'rect');
      cover.setAttribute('x', g.cover.x); cover.setAttribute('y', g.cover.y);
      cover.setAttribute('width', g.cover.w); cover.setAttribute('height', g.cover.h);
      cover.setAttribute('rx', g.cover.rx);
      cover.setAttribute('fill', curBg());
      cover.setAttribute('data-patch-cover', '');
      grp.appendChild(cover);

      // (b) Picto : conteneur SVG imbrique a la boite picto (centre, taille 320).
      var box = document.createElementNS(SVGNS, 'svg');
      box.setAttribute('x', g.picto.cx - g.picto.size / 2);
      box.setAttribute('y', g.picto.cy - g.picto.size / 2);
      box.setAttribute('width', g.picto.size);
      box.setAttribute('height', g.picto.size);
      box.setAttribute('data-patch-picto', '');
      box.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      grp.appendChild(box);

      // (c) Label : <text> Caveat-like (police courante), centre, ink courant.
      var label = mkText({
        'class': 'hsp-grid-date',
        x: g.label.x, y: g.label.y,
        'font-family': fontFamily,
        'font-size': Math.round(g.label.size * fontScale),
        'font-weight': 700,
        fill: INK
      });
      label.setAttribute('data-patch-label', '');
      label.textContent = data.label || '';
      grp.appendChild(label);

      overlay.appendChild(grp);
      liftTopLayers();

      // Inline + recolore le picto (lazy : ne freeze pas, recolor via var --cN).
      fetchSvgText(data.pictoUrl).then(function (svgText) {
        if (patches[i] == null || patches[i].pictoUrl !== data.pictoUrl) return;
        var live = patchGroup(i);
        if (!live) return;
        var holder = live.querySelector('[data-patch-picto]');
        if (!holder) return;
        var wrap = document.createElement('span');
        wrap.innerHTML = svgText;
        var inner = wrap.querySelector('svg');
        if (!inner) return;
        // Reprend le viewBox source ; nettoie width/height pour scaler dans la boite.
        var vb = inner.getAttribute('viewBox');
        holder.innerHTML = '';
        if (vb) holder.setAttribute('viewBox', vb);
        while (inner.firstChild) holder.appendChild(inner.firstChild);
      }).catch(function () { /* echec silencieux : cache + label restent */ });
    }

    // ---------- Recoloration globale des patches (palette / ink) ----------
    function recolorPatches() {
      var pal = curPalette();
      var bg = curBg();
      patchKeys().forEach(function (i) {
        var grp = patchGroup(i);
        if (!grp) return;
        applyPaletteVars(grp, pal);
        var cover = grp.querySelector('[data-patch-cover]');
        if (cover) cover.setAttribute('fill', bg);
        var label = grp.querySelector('[data-patch-label]');
        if (label) label.setAttribute('fill', INK);
      });
    }
    function recolorPatchInk() {
      patchKeys().forEach(function (i) {
        var grp = patchGroup(i);
        if (!grp) return;
        var label = grp.querySelector('[data-patch-label]');
        if (label) label.setAttribute('fill', INK);
      });
    }
    // Quand la police/taille change, re-fitte aussi les labels patchees.
    function refitPatchLabels() {
      patchKeys().forEach(function (i) {
        var grp = patchGroup(i);
        if (!grp) return;
        var label = grp.querySelector('[data-patch-label]');
        if (!label) return;
        label.style.fontFamily = fontFamily;
        label.setAttribute('font-size', Math.round(cellGeom(i).label.size * fontScale));
      });
    }

    // Expose les hooks vers les fonctions externes (palette/ink/font/total/cart).
    hsPersoRecolor = recolorPatches;
    hsPersoRecolorInk = recolorPatchInk;
    hsPersoActive = persoActive;

    // ---------- Bandeau supplement + reset global ----------
    var banner = form.querySelector('[data-perso-banner]');
    var resetAllBtn = form.querySelector('[data-perso-reset]');
    function syncBanner() {
      if (banner) banner.classList.toggle('is-on', persoActive());
      updateTotal();
    }
    function resetAll() {
      patchKeys().forEach(function (i) {
        var grp = patchGroup(i);
        if (grp) grp.parentNode.removeChild(grp);
      });
      patches = {};
      liftTopLayers();
      syncBanner();
    }
    if (resetAllBtn) resetAllBtn.addEventListener('click', resetAll);

    // ---------- PICKER (modal) ----------
    var picker      = root.querySelector('[data-picker]');
    var pickGrid    = picker ? picker.querySelector('[data-picker-grid]') : null;
    var pickSearch  = picker ? picker.querySelector('[data-picker-search]') : null;
    var pickLabel   = picker ? picker.querySelector('[data-picker-label]') : null;
    var pickApply   = picker ? picker.querySelector('[data-picker-apply]') : null;
    var pickCellRst = picker ? picker.querySelector('[data-picker-cellreset]') : null;
    var pickIO      = null;  // IntersectionObserver lazy-load des SVG inline
    var curCell     = -1;    // case en cours d'edition
    var curPick     = null;  // { cdnUrl, title } picto selectionne dans le picker
    var renderToken = 0;     // invalide les rendus de grille obsoletes

    function setupIO() {
      if (pickIO || !('IntersectionObserver' in window)) return;
      pickIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (ent) {
          if (!ent.isIntersecting) return;
          var cell = ent.target;
          pickIO.unobserve(cell);
          inlineCellSvg(cell);
        });
      }, { root: pickGrid, rootMargin: '200px' });
    }

    function inlineCellSvg(cell) {
      if (cell.dataset.inlined === '1') return;
      var url = cell.getAttribute('data-cdn');
      if (!url) return;
      cell.dataset.inlined = '1';
      fetchSvgText(url).then(function (txt) {
        if (!cell.isConnected || cell.getAttribute('data-cdn') !== url) return;
        var wrap = document.createElement('span');
        wrap.innerHTML = txt;
        var svg = wrap.querySelector('svg');
        if (!svg) return;
        svg.removeAttribute('width'); svg.removeAttribute('height');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        cell.innerHTML = '';
        cell.appendChild(svg);
      }).catch(function () { cell.dataset.inlined = ''; });
    }

    function renderResults(items) {
      var token = ++renderToken;
      if (!pickGrid) return;
      if (!items.length) {
        pickGrid.innerHTML = '<div class="hsp-picker__state">Aucune illustration</div>';
        return;
      }
      // Limite l'affichage initial (perf) ; la recherche reduit deja le set.
      var slice = items.slice(0, 240);
      pickGrid.innerHTML = '';
      var pal = curPalette();
      slice.forEach(function (it) {
        var cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'hsp-picker__cell';
        cell.setAttribute('data-cdn', it.cdnUrl);
        cell.setAttribute('data-title', it.title);
        cell.setAttribute('role', 'option');
        cell.setAttribute('aria-label', it.title);
        cell.title = it.title;
        applyPaletteVars(cell, pal);
        if (curPick && curPick.cdnUrl === it.cdnUrl) cell.classList.add('is-active');
        // Placeholder <img> tant que le SVG inline n'est pas charge (lazy).
        var img = document.createElement('img');
        img.src = it.cdnUrl; img.alt = ''; img.loading = 'lazy';
        cell.appendChild(img);
        pickGrid.appendChild(cell);
        if (pickIO) pickIO.observe(cell); else inlineCellSvg(cell);
      });
      if (token !== renderToken) return;
    }

    function applyFilter() {
      if (!manifestItems) return;
      var q = (pickSearch ? pickSearch.value : '').trim().toLowerCase();
      // Recherche vide : on N'AFFICHE PAS les ~545 pictos (rendu lourd = freeze).
      // On invite a taper un mot-cle ; les resultats n'apparaissent qu'au filtrage.
      if (!q) {
        if (pickGrid) {
          pickGrid.innerHTML = '<div class="hsp-picker__state">Tapez un mot-clé pour trouver un picto, par exemple « ballon », « étoile », « chat », « fusée », « cœur »…</div>';
        }
        return;
      }
      var list = manifestItems.filter(function (it) { return it.kw.indexOf(q) !== -1; });
      renderResults(list);
    }

    function openPicker(i) {
      if (!picker) return;
      curCell = i;
      var existing = patches[i] || null;
      curPick = existing ? { cdnUrl: existing.pictoUrl, title: existing.label } : null;
      // Intitule prerempli : libelle patche s'il existe, sinon libelle courant du canvas.
      if (pickLabel) pickLabel.value = existing ? (existing.label || '') : (MILESTONES[i] || '');
      if (pickSearch) pickSearch.value = '';
      if (pickApply) pickApply.disabled = !curPick;
      if (pickCellRst) pickCellRst.hidden = !existing;
      picker.classList.add('is-open');
      picker.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setupIO();
      if (pickGrid) pickGrid.innerHTML = '<div class="hsp-picker__state">Chargement…</div>';
      loadManifest().then(function () { applyFilter(); })
        .catch(function () {
          if (pickGrid) pickGrid.innerHTML = '<div class="hsp-picker__state hsp-picker__state--err">Impossible de charger les illustrations.</div>';
        });
      if (pickLabel) setTimeout(function () { pickLabel.focus(); }, 30);
    }

    function closePicker() {
      if (!picker) return;
      picker.classList.remove('is-open');
      picker.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      curCell = -1; curPick = null;
    }

    // Selection d'une vignette dans la grille.
    if (pickGrid) {
      pickGrid.addEventListener('click', function (e) {
        var cell = e.target.closest ? e.target.closest('.hsp-picker__cell') : null;
        if (!cell) return;
        pickGrid.querySelectorAll('.hsp-picker__cell.is-active').forEach(function (c) { c.classList.remove('is-active'); });
        cell.classList.add('is-active');
        curPick = { cdnUrl: cell.getAttribute('data-cdn'), title: cell.getAttribute('data-title') };
        if (pickApply) pickApply.disabled = false;
      });
    }
    if (pickSearch) pickSearch.addEventListener('input', applyFilter);

    // Appliquer : enregistre le patch + re-render l'overlay de la case.
    if (pickApply) pickApply.addEventListener('click', function () {
      if (curCell < 0 || !curPick) return;
      var label = (pickLabel ? pickLabel.value : '').trim() || (MILESTONES[curCell] || '');
      patches[curCell] = { pictoUrl: curPick.cdnUrl, label: label };
      renderPatch(curCell);
      syncBanner();
      closePicker();
    });

    // Reinitialiser cette case (retire le patch ; revient au canvas cuit).
    if (pickCellRst) pickCellRst.addEventListener('click', function () {
      if (curCell < 0) return;
      delete patches[curCell];
      renderPatch(curCell);
      syncBanner();
      closePicker();
    });

    picker && picker.querySelectorAll('[data-picker-cancel]').forEach(function (el) {
      el.addEventListener('click', closePicker);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && picker && picker.classList.contains('is-open')) closePicker();
    });

    // Re-fit des labels patchees quand la police / taille du texte change.
    form.querySelectorAll('.hsp-fontbtn, .hsp-sizebtn').forEach(function (btn) {
      btn.addEventListener('click', function () { refitPatchLabels(); });
    });

    // ---------- Expose au submit : payload panier ----------
    // _hs_patches = tableau d'items prets a rendre (cover/picto/label calcules via cellGeom).
    window.__hsBuildPersoPayload = function () {
      if (!persoActive()) return null;
      var pal = curPalette();
      var P = PALETTES[pal] || {};
      var arr = [];
      var visibleProps = {};
      patchKeys().map(Number).sort(function (a, b) { return a - b; }).forEach(function (i) {
        var data = patches[i];
        var g = cellGeom(i);
        arr.push({
          cell: i,
          cover: { x: g.cover.x, y: g.cover.y, w: g.cover.w, h: g.cover.h, rx: g.cover.rx, fill: curBg() },
          picto: { url: data.pictoUrl, cx: g.picto.cx, cy: g.picto.cy, size: g.picto.size },
          label: {
            text: data.label || '', x: g.label.x, y: g.label.y,
            size: Math.round(g.label.size * fontScale), fill: INK,
            family: printFamily, anchor: 'middle'
          }
        });
        visibleProps['Case ' + (i + 1) + ' personnalisée'] = data.label || '';
      });
      return {
        items: arr,
        palette: { c1: P.c1, c2: P.c2, c3: P.c3, c4: P.c4, c5: P.c5, c6: P.c6, bg: P.bg, ink: P.ink },
        visibleProps: visibleProps,
        variantId: PERSO_VARIANT_ID
      };
    };
  })();

  // ---------- Add-to-cart JS multi-items (produit + upsells en une requete) ----------
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // Validation : prenom requis.
    if (!inputPrenom.value.trim()) {
      inputPrenom.focus();
      form.classList.add('hsp-form--invalid');
      return;
    }
    form.classList.remove('hsp-form--invalid');

    // Recalcul d'un fit final juste avant l'envoi.
    applyFont();

    var finalPrenom = inputPrenom.value.trim() || samplePrenom;
    var v = findVariant();

    // ---------- Properties visibles client : prenom + une par etape renseignee ----------
    var properties = {};
    properties['Prénom'] = finalPrenom;
    var datesFR = [];
    for (var j = 0; j < 12; j++) {
      var fr = fmtDate(dateInputs[j] ? dateInputs[j].value : '');
      datesFR[j] = fr;
      if (fr) properties[MILESTONES[j]] = fr; // ex "Premiers pas" = "12.03.2024"
    }
    if (handDates) properties['Dates à compléter à la main'] = 'Oui';
    if (canvasPalette && CANVAS_BY_PALETTE[canvasPalette]) {
      properties['Couleur des illustrations'] = (PALETTES[canvasPalette] || {}).label || canvasPalette;
    }
    properties['Couleur du fond']  = bgName;
    properties['Couleur du texte'] = inkName;
    properties['Police']           = printFamily;
    properties['Taille du texte']  = (form.querySelector('.hsp-sizebtn.is-active') || {}).textContent || 'Moyen';

    // ---------- Properties cachees pour le Worker print (prefixe "_") ----------
    // _hs_grid = tableau d'items prets a rendre (prenom + 12 dates). Le Worker
    // pose chaque item tel quel sur le canvas a la resolution print.
    var gridItems = [];
    gridItems.push({
      x: LAYOUT.prenom.x, y: LAYOUT.prenom.y,
      size: slots.prenom.fitted, text: finalPrenom,
      anchor: 'middle', family: printFamily, fill: INK
    });
    var handFill = placeholderFill(); // teinte claire de l'emplacement vierge
    for (var g = 0; g < 12; g++) {
      // Par-cellule, identique a l'apercu : date (encre) / emplacement vierge
      // (teinte claire, si toggle ON) / rien. Une case datee n'affiche jamais
      // l'emplacement. Le Worker rend ce texte tel quel => impression = apercu.
      var cellText = datesFR[g] || (handDates ? HAND_PLACEHOLDER : '');
      var cellFill = datesFR[g] ? INK : (handDates ? handFill : INK);
      gridItems.push({
        x: LAYOUT.dates[g].x, y: LAYOUT.dates[g].y,
        size: slots[g].fitted, text: cellText,
        anchor: 'middle', family: printFamily, fill: cellFill
      });
    }

    properties['_hs_mode']       = 'grid';
    properties['_hs_canvas_url'] = CANVAS_URL;   // canvas SANS texte (transparent, 2400 large, https:)
    properties['_hs_bg']         = bgColor;      // couleur de fond hex (le Worker peint le fond)
    properties['_hs_ink']        = INK;          // couleur d'encre hex
    // _hs_palette envoye SYSTEMATIQUEMENT (= palette d'illustrations selectionnee) pour que
    // le Worker print recolore le motif de fond meme SANS upsell perso. Le bloc perso plus bas
    // le reecrit a l'identique (meme palette). Sans accent (les PALETTES n'en ont pas -> le
    // motif retombe sur c2, comme a l'ecran).
    var _selPal = PALETTES[canvasPalette] || PALETTES[HERO_PALETTE];
    properties['_hs_palette']    = JSON.stringify({ c1: _selPal.c1, c2: _selPal.c2, c3: _selPal.c3, c4: _selPal.c4, c5: _selPal.c5, c6: _selPal.c6, bg: _selPal.bg, ink: _selPal.ink });
    properties['_hs_font']       = printFamily;  // family-name exact cote Worker print
    properties['_hs_fontscale']  = fontScale;    // multiplicateur de taille
    properties['_hs_format']     = (v && v.format) || sel['1'] || '';
    properties['_hs_cadre']      = (v && v.cadre)  || sel['2'] || '';
    // Mode numérique : format/cadre forcés + props visibles (le produit digital
    // standalone n'a pas d'option Format — le worker rend en 'numerique').
    if (isDigitalMode() && DIGITAL) {
      properties['_hs_format'] = 'numerique';
      properties['_hs_cadre']  = 'sans';
      properties['Format']     = 'Fichier numérique HD';
      properties['Modèle']     = HSP_CFG.productTitle || document.title;
    }
    properties['_hs_grid']       = JSON.stringify(gridItems);

    // ---------- Sans la mention happilystory (upsell +2,99 €) ----------
    if (noWatermark) {
      properties['_hs_nowatermark'] = 'true';            // lu par le Worker print
      properties['Sans mention happilystory'] = 'Oui';   // visible au panier
    }

    // ---------- Illustrations personnalisees (upsell +5,99 €) ----------
    // _hs_patches : le Worker dessine cover (repeint la case) + picto + label par-dessus
    // le canvas cuit. Le cache recouvre l'ancien picto+label cuits => pas de doublon.
    var persoPayload = null;
    try {
      persoPayload = (typeof window.__hsBuildPersoPayload === 'function')
        ? window.__hsBuildPersoPayload() : null;
    } catch (errPerso) {
      persoPayload = null; // jamais bloquer l'ajout panier a cause de la perso
    }
    if (persoPayload) {
      properties['_hs_patches'] = JSON.stringify(persoPayload.items);
      properties['_hs_palette'] = JSON.stringify(persoPayload.palette);
      Object.keys(persoPayload.visibleProps).forEach(function (k) {
        properties[k] = persoPayload.visibleProps[k]; // "Case <n> personnalisée" = intitule
      });
    }

    // ---------- Bordure decorative (GRATUITE) ----------
    // _hs_sig_y envoye TOUJOURS (= 3035) pour coherence worker, meme sans bordure.
    // Si bordure choisie : _hs_border_url + _hs_border_color (hex resolu) + props visibles.
    var borderPayload = null;
    try {
      borderPayload = (typeof window.__hsBuildBorderPayload === 'function')
        ? window.__hsBuildBorderPayload() : null;
    } catch (errBorder) {
      borderPayload = null; // jamais bloquer l'ajout panier a cause de la bordure
    }
    properties['_hs_sig_y'] = (borderPayload && borderPayload.sigY) || LAYOUT.signature.y;
    if (borderPayload && borderPayload.url) {
      properties['_hs_border_url']   = borderPayload.url;   // URL asset de la bordure
      properties['_hs_border_color'] = borderPayload.color; // hex resolu (assortie ou custom)
      properties['Bordure']          = borderPayload.label; // visible au panier
      properties['Couleur bordure']  = borderPayload.colorName;
    }

    // ---------- Fond MOTIF (GRATUIT) ----------
    // _hs_motif = id du motif (lu par le Worker print plus tard). Prop visible "Fond"
    // = libelle du motif, uniquement si != Aucun.
    var motifPayload = null;
    try {
      motifPayload = (typeof window.__hsBuildMotifPayload === 'function')
        ? window.__hsBuildMotifPayload() : null;
    } catch (errMotif) {
      motifPayload = null; // jamais bloquer l'ajout panier a cause du motif
    }
    properties['_hs_motif'] = (motifPayload && motifPayload.id) || 'none';
    if (motifPayload && motifPayload.id && motifPayload.id !== 'none') {
      properties['Fond'] = motifPayload.label; // visible au panier
    }

    // Jeton de groupe : appaire l'affiche et ses upsells de ce clic (réplique 13×18).
    var _hsGrp = (typeof window.hsNewGroupToken === 'function') ? window.hsNewGroupToken() : null;
    if (_hsGrp) properties['_hs_group'] = _hsGrp;
    var mainItem = { id: variantId, quantity: 1, properties: properties };
    var items = [mainItem];
    if (typeof window.hsCollectUpsells === 'function') {
      items = items.concat(window.hsCollectUpsells(_hsGrp));
    }
    if (noWatermark && WATERMARK_VARIANT_ID) {
      items.push({ id: WATERMARK_VARIANT_ID, quantity: 1, properties: { _hs_for: 'watermark' } });
    }
    if (persoPayload && persoPayload.variantId) {
      items.push({ id: persoPayload.variantId, quantity: 1, properties: { _hs_for: 'perso' } });
    }

    if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d && d.description || 'Erreur panier'); });
        return r.json();
      })
      .then(function () {
        // Tiroir panier latéral (pattern sportsndeco) — repli page /cart si absent.
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
        if (window.snRefreshCartDrawer && window.snOpenCartDrawer) {
          Promise.resolve(window.snRefreshCartDrawer()).then(function () { window.snOpenCartDrawer(); });
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
        form.classList.add('hsp-form--invalid');
        if (window.console) console.error('[happilystory] add to cart failed:', err);
        alert('Désolé, l\'ajout au panier a échoué. Merci de réessayer.');
      });
  });
})();
